import React from 'react';

function ServiceRequestForm() {
  return (
    <section id="service-request" className="service-request-section">
      <div className="container">
        <h2 className="section-title">Service Request Form</h2>

        <div className="form-download-content">
          <div className="intro-message">
            <p>
              Thank you for considering us for your funeral service needs. We are honored to assist you during this important time.
              To help us serve you better, please follow the instructions below to download, complete, and return our Service Request Form.
            </p>
          </div>

          <div className="download-section">
            <a
              href="/Morning Light Request Form 2026.pdf"
              download="Morning Light Request Form 2026.pdf"
              className="btn-primary btn-large download-btn"
            >
              📄 Download Service Request Form (PDF)
            </a>
          </div>

          <div className="instructions-container">
            <div className="instruction-step">
              <div className="step-number">I.</div>
              <div className="step-content">
                <h3>Download or Save the Attachment</h3>
                <p>Click the download button above and choose "Download" or "Save" to save the file to your computer.</p>
                <div className="note-box">
                  <strong>Please note:</strong> Most operating systems will automatically save downloaded files to a "Downloads" folder.
                  You may also choose to save the file to a specific location, such as your "Documents" or "Desktop" folder, for easy access.
                </div>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">II.</div>
              <div className="step-content">
                <h3>Complete the Service Request Form</h3>
                <p>Please fill out the Service Request Form to the best of your knowledge.</p>
                <p>Fields highlighted in <span className="red-text">RED</span> indicate key information we require to serve you effectively. This includes:</p>
                <ul>
                  <li>The individual or organization directing or conducting the funeral service</li>
                  <li>Any equipment and/or staff you will need from Morning Light</li>
                  <li>The type of remains (e.g., casketed, cremated) our equipment will be used with, to ensure proper and respectful handling</li>
                </ul>
                <p><em>If you're unsure about any section, feel free to contact us—we're here to assist you.</em></p>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">III.</div>
              <div className="step-content">
                <h3>Saving and Renaming the Service Request Form</h3>
                <p>Once you have completed the form, we recommend saving it under a new, personalized file name to avoid confusion with the blank, generic version.</p>
                <p><strong>To do this:</strong></p>
                <ol>
                  <li>Click "File" in the top left corner of your PDF reader.</li>
                  <li>From the dropdown menu, select "Save As."</li>
                  <li>Choose a folder or location on your computer where you'd like to save the file.</li>
                  <li>Rename the file using a clear and identifiable name — for example: <strong>Doe, John – 21 Jan 2025</strong></li>
                </ol>
                <p>This will make it easier to locate the document later and helps us identify the request quickly when submitted.</p>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">IV.</div>
              <div className="step-content">
                <h3>Submitting the Service Request Form</h3>
                <p>The final step is to submit your completed Service Request Form to Funeral Services via email.</p>
                <p><strong>To do so:</strong></p>
                <ol>
                  <li>Open your preferred email provider and create a new email.</li>
                  <li>In the "To" field, enter our request email address: <strong>request@mlfuneral.com</strong></li>
                  <li>In the Subject line, please include:
                    <ul>
                      <li>The name of the mortuary</li>
                      <li>The name of the decedent</li>
                      <li>(Example: "Morning Light Mortuary – Doe, John")</li>
                    </ul>
                  </li>
                  <li>Attach the finalized Service Request Form by selecting the file from your computer or device.</li>
                  <li>Once everything is ready and the file is attached, click "Send."</li>
                </ol>
                <div className="note-box">
                  <strong>Important:</strong> If you do not receive a confirmation from us within 48 hours, please feel free to follow up by phone or email.
                </div>
              </div>
            </div>
          </div>

          <div className="contact-info-box">
            <h3>Contact Information</h3>
            <p><strong>Email:</strong> <a href="mailto:request@mlfuneral.com">request@mlfuneral.com</a></p>
            <p><strong>Alternative Email:</strong> <a href="mailto:morninglight.fs@outlook.com">morninglight.fs@outlook.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+19099258671">(909) 925-8671</a></p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceRequestForm;
